import { render, staticRenderFns } from "./EmptyCart.vue?vue&type=template&id=a61aa7f8&"
import script from "./EmptyCart.vue?vue&type=script&lang=js&"
export * from "./EmptyCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports